import omOssBg from '@/assets/om-oss-bg.avif';
import jesperTasteTest from '@/assets/jesper-new-taste-test.png';
import customerReactionSpenst from '@/assets/customer-reaction-spenst.png';
import stoadTopView from '@/assets/stoad-top-view.jpg';
import stoadFrontView from '@/assets/stoad-front-view.jpg';
import stoadMachineSide from '@/assets/stoad-machine-side.jpeg';
import stoadMachineFront from '@/assets/stoad-machine-front.jpeg';
import stoadCamMechanism from '@/assets/stoad-cam-mechanism.jpeg';
import patentLidTop from '@/assets/patent-lid-top-new.png';
import patentPartsExploded from '@/assets/patent-parts-exploded-new.png';
import patentMeasuringScoops from '@/assets/patent-measuring-scoops-new.png';
import patentMechanismSide from '@/assets/patent-mechanism-side-new.png';
import patentMeasuringInside from '@/assets/patent-measuring-inside.png';
import { Card } from '@/components/ui/card';
import CountUpStats from '@/components/CountUpStats';
const OmOss = () => {
  return <div className="min-h-screen bg-black">
      {/* Hero Section - Full Width */}
      <section className="relative min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center" style={{
      backgroundImage: `url(${omOssBg})`
    }}>
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative z-10 text-center space-y-4 md:space-y-8 px-4 py-12 md:py-0 max-w-6xl">
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-9xl font-bold text-white mb-4 md:mb-8 tracking-tight">
            OM <span className="gradient-text">PEVEO</span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/90 max-w-4xl mx-auto leading-relaxed font-light">Historien om hvordan en geologstudent fra Førde revolusjonerte norsk pwo-industri</p>
        </div>
      </section>

      {/* Content Sections - Alternating backgrounds with Timeline */}
      <div className="relative">
        {/* Vertical Timeline Line */}
        <div className="absolute left-[15px] md:left-[31px] top-0 bottom-0 w-1 bg-gradient-to-b from-yellow-400 via-orange-500 to-yellow-400 shadow-lg shadow-yellow-400/30 hidden md:block z-0" />
        
      {/* Section 1 - Dark */}
      <section className="py-12 md:py-20 lg:py-24 bg-black relative">
        {/* Timeline marker */}
        <div className="absolute left-4 md:left-8 top-20 hidden md:block">
          <div className="w-4 h-4 bg-yellow-400 rounded-full -ml-2 shadow-lg shadow-yellow-400/50 border-2 border-white" />
          <div className="absolute left-6 -top-1 whitespace-nowrap">
            <span className="text-sm font-bold text-yellow-400">2022</span>
            <span className="block text-xs text-white/70">Starten på revolusjonen</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 md:pl-20">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 md:mb-8 leading-tight">
                Starten på<br />
                <span className="gradient-text">peveo</span>
              </h2>
            </div>
            <div>
              <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed mb-4 md:mb-6">
                Jeg startet PEVEO i 2022. Som treningsnerd med geologhjerne var jeg lei av underdoserte, overprisede PWO-er. Ambisjonen min var like enkel som kompromissløs: lage produkter jeg selv kan stå hundre prosent inne for – med dokumentert effekt, maksimal dosering og en pris som faktisk gir mening.
              </p>
            <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
              Det begynte som et prosjekt for meg og gjengen, men ryktet spredte seg, og ganske snart ville «alle» teste "den sterke fra Førde" - den første høy doserte L-citrulline PWO-en i Norge.
            </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 - Dark Gray */}
      <section className="py-12 md:py-20 lg:py-24 bg-zinc-900 relative">
        {/* Timeline marker */}
        <div className="absolute left-4 md:left-8 top-20 hidden md:block">
          <div className="w-4 h-4 bg-orange-500 rounded-full -ml-2 shadow-lg shadow-orange-500/50 border-2 border-white" />
          <div className="absolute left-6 -top-1 whitespace-nowrap">
            <span className="text-sm font-bold text-orange-400">Mai 2023</span>
            <span className="block text-xs text-white/70">Gjennombruddet</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 md:pl-20">
          <div className="text-center mb-8 md:mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 lg:mb-8">
              Mai 2023: <span className="gradient-text">Gjennombruddet</span>
            </h2>
          </div>
          
          <Card className="p-6 md:p-10 lg:p-12 bg-zinc-800/50 border-zinc-700 backdrop-blur">
            <CountUpStats />
          </Card>
        </div>
      </section>

      {/* Section 3 - Black */}
      <section className="py-12 md:py-20 lg:py-24 bg-black relative">
        {/* Timeline marker */}
        <div className="absolute left-4 md:left-8 top-20 hidden md:block">
          <div className="w-4 h-4 bg-yellow-400 rounded-full -ml-2 shadow-lg shadow-yellow-400/50 border-2 border-white" />
          <div className="absolute left-6 -top-1 whitespace-nowrap">
            <span className="text-sm font-bold text-yellow-400">2023</span>
            <span className="block text-xs text-white/70">Vitenskap først</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 md:pl-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center mb-8 md:mb-12 lg:mb-16">
            <span className="gradient-text">Vitenskap</span> først, markedsføring etterpå
          </h2>
          
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
            <div>
              <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed mb-6 md:mb-8">
                Vi jobber vitenskap først, markedsføring etterpå. Hvert produkt har forskningsgrunnlag, dosene er effektive – ikke symbolske – og produksjonen skjer i Sverige med batcher som er testet, verifisert og dopingfrie.
              </p>
              <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
                Vi vil at du skal føle deg premium uten at lommeboken gjør det, og vi garanterer Norges beste pris på sammenlignbare produkter. Sjekk gjerne andre nettsider; vi tåler sammenligning.
              </p>
            </div>
            
            <Card className="p-8 bg-gradient-to-br from-zinc-800/50 to-zinc-900/50 border-zinc-700">
              <h3 className="text-2xl font-bold text-white mb-6">Våre prinsipper</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-white/90">Dokumentert effekt, ikke bare påstander</span>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-white/90">Maksimal dosering, ikke symbolske mengder</span>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-white/90">Testet og verifisert i Sverige</span>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-white/90">Norges beste pris på sammenlignbare produkter</span>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>

      {/* Section 4 - Smak Revolution */}
      <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-zinc-900 to-black relative">
        {/* Timeline marker */}
        <div className="absolute left-4 md:left-8 top-20 hidden md:block">
          <div className="w-4 h-4 bg-orange-500 rounded-full -ml-2 shadow-lg shadow-orange-500/50 border-2 border-white" />
          <div className="absolute left-6 -top-1 whitespace-nowrap">
            <span className="text-sm font-bold text-orange-400">2024</span>
            <span className="block text-xs text-white/70">Smak-revolusjonen</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 md:pl-20">
          <div className="text-center mb-6 md:mb-8 lg:mb-10">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 md:mb-6">
              Smak <span className="gradient-text">betyr noe</span>
            </h2>
            <p className="text-base md:text-lg text-white/80 max-w-3xl mx-auto">
              Over 200 mennesker i blindtest kan ikke ta feil
            </p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-6 md:gap-8 mb-6">
            <div className="lg:col-span-2">
              <p className="text-base sm:text-lg text-white/90 leading-relaxed mb-4">
                Smak betyr faktisk noe. I 2022 startet vi med fruit punch, testet blant venner, familie og et bredt treningsnettverk på Spenst Førde. To år senere tok vi neste steg: en blindtest med over 200 deltakere der rekkefølgen ble randomisert for hver person, rating ble gitt på en 1–10-skala, og deltakerne kunne justere vurderingene sine underveis.
              </p>
              <p className="text-base sm:text-lg text-white/90 leading-relaxed mb-4 md:mb-6">
                Tre citrus, tre tropiske, en fruit punch, en sour apple og noen bonussmaker gikk i mikseren. Resultatet var tydelig: citrus vant overlegent med snitt rundt 8,3-8,6, tropisk fulgte pa 7,5-7,8, fruit punch landet pa 7,1 og sour apple stoppet pa 6,4. Signifikansen var p mindre enn 0,01. Derfor satser vi pa en smak - den flest faktisk liker best. Vi nekter a tro at noen har lagt ned mer arbeid i a perfeksjonere en smak.
              </p>
              
              {/* Taste boxes moved under text */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                <div className="text-center p-3 md:p-4 bg-gradient-to-br from-yellow-500/10 to-orange-500/10 rounded-lg border border-yellow-500/20">
                  <div className="text-xl md:text-2xl font-bold text-yellow-400 mb-1 md:mb-2">8.3-8.6</div>
                  <div className="text-white font-medium text-sm md:text-base">🥇 Citrus</div>
                  <div className="text-white/60 text-xs md:text-sm">Vinner</div>
                </div>
                <div className="text-center p-3 md:p-4 bg-zinc-800/50 rounded-lg border border-zinc-600">
                  <div className="text-xl md:text-2xl font-bold text-white mb-1 md:mb-2">7.5-7.8</div>
                  <div className="text-white font-medium text-sm md:text-base">🥈 Tropisk</div>
                  <div className="text-white/60 text-xs md:text-sm">Andreplass</div>
                </div>
                <div className="text-center p-3 md:p-4 bg-zinc-800/50 rounded-lg border border-zinc-600">
                  <div className="text-xl md:text-2xl font-bold text-white mb-1 md:mb-2">7.1</div>
                  <div className="text-white font-medium text-sm md:text-base">🥉 Fruit Punch</div>
                  <div className="text-white/60 text-xs md:text-sm">Tredjeplass</div>
                </div>
                <div className="text-center p-3 md:p-4 bg-zinc-800/50 rounded-lg border border-zinc-600">
                  <div className="text-xl md:text-2xl font-bold text-white mb-1 md:mb-2">6.4</div>
                  <div className="text-white font-medium text-sm md:text-base">🍎 Sour Apple</div>
                  <div className="text-white/60 text-xs md:text-sm">Fjerdeplass</div>
                </div>
              </div>
            </div>
            
            {/* Jesper image moved here */}
            <div className="lg:col-span-1 flex flex-col justify-end">
              <div className="bg-black/50 p-3 md:p-4 rounded-lg border border-zinc-600 mb-4">
                <img src={jesperTasteTest} alt="Jesper under smaktest" className="rounded-md w-full h-auto" />
                <p className="text-white/60 text-xs md:text-sm text-center mt-2 md:mt-3 italic">
                  Jesper under smaktestingen
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col lg:flex-row gap-6 items-center mb-6">
            <div className="bg-black/30 p-4 rounded-lg border border-zinc-600 lg:max-w-sm flex-shrink-0 w-full">
              <img src={customerReactionSpenst} alt="Kunder som smakter Citrus-varianten på Spenst Shop" className="rounded-md w-full h-auto object-cover" />
              <p className="text-white/60 text-xs text-center mt-3 italic">
                Kundenes spontane reaksjon på Citrus-smaken på Spenst Shop
              </p>
            </div>
            <div className="flex-1 lg:pl-4">
              <h4 className="text-xl md:text-2xl font-bold text-yellow-400 mb-3 md:mb-4">Reaksjonen sier alt</h4>
              <p className="text-base md:text-lg text-white/90 leading-relaxed">
                Her ser du den ekte reaksjonen fra en kunde på Spenst Shop da han smakte Citrus-varianten for første gang. Over 200 smaktestere kan ikke ta feil.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Section 5 - Verdiprosjekt */}
      <section className="py-12 md:py-20 lg:py-24 bg-black relative">
        {/* Timeline marker */}
        <div className="absolute left-4 md:left-8 top-20 hidden md:block">
          <div className="w-4 h-4 bg-yellow-400 rounded-full -ml-2 shadow-lg shadow-yellow-400/50 border-2 border-white" />
          <div className="absolute left-6 -top-1 whitespace-nowrap">
            <span className="text-sm font-bold text-yellow-400">2024</span>
            <span className="block text-xs text-white/70">Verdiprosjekt</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 md:pl-20">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 md:mb-8 leading-tight">
                Mer enn bare<br />
                <span className="gradient-text">profitt</span>
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
                PEVEO er også et verdiprosjekt. Overskuddet vårt går til løsninger som hjelper folk med kneplager og bevegelsesutfordringer, og hver boks bidrar til noe større. For å maksimere farten i utviklingen har grunnleggeren til nå valgt å ikke ta ut lønn; i stedet er alt reinvestert i produktforbedringer, patenter og prototyper.
              </p>
            </div>
            
            <Card className="p-8 bg-gradient-to-br from-zinc-800/50 to-zinc-900/50 border-zinc-700">
              <blockquote className="text-2xl text-white font-bold italic mb-6">
                "Slik holder vi prisene lave, tempoet høyt og ambisjonene store – samtidig som vi bygger en modell som skal være bærekraftig på sikt."
              </blockquote>
              <div className="text-white/60">— Jesper Hammersvik, Grunnlegger</div>
            </Card>
          </div>
        </div>
      </section>

      {/* Section 6 - Innovation */}
      <section className="py-12 md:py-20 lg:py-24 bg-white relative">
        {/* Timeline marker */}
        <div className="absolute left-4 md:left-8 top-20 hidden md:block">
          <div className="w-4 h-4 bg-orange-500 rounded-full -ml-2 shadow-lg shadow-orange-500/50 border-2 border-black" />
          <div className="absolute left-6 -top-1 whitespace-nowrap">
            <span className="text-sm font-bold text-orange-500">2024-2025</span>
            <span className="block text-xs text-black/70">Patent-innovasjon</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 md:pl-20">
          <div className="grid lg:grid-cols-12 gap-8">
            {/* Left side - Main content */}
            <div className="lg:col-span-8 space-y-8">
              <div className="mb-8">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-4">
                  Patent-<span className="gradient-text">innovasjon</span>
                </h2>
                <p className="text-lg sm:text-xl md:text-2xl text-black/70 font-light">Vi fikser irritasjoner, ikke gimmicker</p>
              </div>
              <div className="grid md:grid-cols-2 gap-8">
                <Card className="p-8 bg-white/80 backdrop-blur border-yellow-500/30 shadow-lg">
                  <div className="text-4xl mb-6">💡</div>
                  <h3 className="text-2xl font-bold text-black mb-4">Scoop under lokket</h3>
                  <p className="text-xl text-black/80 leading-relaxed">
                    Så du slipper å grave som en arkeolog i pulveret. En integrert løsning som gir riktig mengde – enkelt, rent og praktisk – og som fungerer i hverdagen, ikke bare på tegnebrettet.
                  </p>
                </Card>
                
                <Card className="p-8 bg-white/80 backdrop-blur border-blue-500/30 shadow-lg">
                  <div className="text-4xl mb-6">🎯</div>
                  <h3 className="text-2xl font-bold text-black mb-4">Glycerol i lokket</h3>
                  <p className="text-xl text-black/80 leading-relaxed">
                    Fordi dagens PWO-er ofte underdoserer glycerol grovt. Målet er en integrert løsning som gir riktig mengde glycerol hver gang.
                  </p>
                </Card>
              </div>
              
              <Card className="p-8 md:p-12 bg-white/90 backdrop-blur border-zinc-300 shadow-xl">
                <p className="text-lg md:text-xl text-black/80 leading-relaxed mb-6">
                  Den ærlige biten er at dette er dyrt: avstøpningsformer, verktøy og design koster, og for å få produksjonen opp må vi lage minst ti tusen lokk. Hver gang du velger oss fremfor konkurrentene, hjelper du direkte til at denne løsningen blir virkelighet.
                </p>
                <p className="text-lg md:text-xl text-black font-bold">
                  Vi lover at det alltid skal være enkelt å handle hos oss: du får det beste produktet til lavere pris – og samtidig skyver du hele bransjen et steg fremover.
                </p>
              </Card>
            </div>
            
            {/* Right side - Small patent images */}
            <div className="lg:col-span-4">
              <div className="lg:sticky lg:top-24">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3">
                  <div className="p-1 rounded-lg hover:scale-105 transition-all">
                    <img src={patentLidTop} alt="Patent lokk topp" className="w-full h-auto object-contain max-h-60 sm:max-h-72 md:max-h-80" />
                  </div>
                  <div className="p-1 rounded-lg hover:scale-105 transition-all">
                    <img src={patentMeasuringInside} alt="Patent måleskjeer inni" className="w-full h-auto object-contain max-h-60 sm:max-h-72 md:max-h-80" />
                  </div>
                  <div className="p-1 rounded-lg hover:scale-105 transition-all">
                    <img src={patentPartsExploded} alt="Patent deler eksplodert" className="w-full h-auto object-contain max-h-60 sm:max-h-72 md:max-h-80" />
                  </div>
                  <div className="p-1 rounded-lg hover:scale-105 transition-all">
                    <img src={patentMeasuringScoops} alt="Patent måleskjeer" className="w-full h-auto object-contain max-h-60 sm:max-h-72 md:max-h-80" />
                  </div>
                  <div className="p-1 rounded-lg hover:scale-105 transition-all sm:col-span-2">
                    <img src={patentMechanismSide} alt="Patent mekanisme side" className="w-full h-auto object-contain max-h-60 sm:max-h-72 md:max-h-80" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 7 - Stoad */}
      <section className="py-12 md:py-20 lg:py-24 bg-black relative">
        {/* Timeline marker */}
        <div className="absolute left-4 md:left-8 top-20 hidden md:block">
          <div className="w-4 h-4 bg-yellow-400 rounded-full -ml-2 shadow-lg shadow-yellow-400/50 border-2 border-white" />
          <div className="absolute left-6 -top-1 whitespace-nowrap">
            <span className="text-sm font-bold text-yellow-400">2025</span>
            <span className="block text-xs text-white/70">STOAD lansering</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 md:pl-20">
          <div className="text-center mb-8 md:mb-12 lg:mb-16">
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 lg:mb-8">
              Introduserer <span className="gradient-text">STOAD</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-white/80 max-w-3xl mx-auto">
              Neste generasjons treningsapparater
            </p>
          </div>
          
          <Card className="p-6 md:p-8 lg:p-12 bg-gradient-to-br from-zinc-800/30 to-zinc-900/30 border-zinc-700 backdrop-blur">
            <div className="grid lg:grid-cols-3 gap-6 md:gap-8 lg:gap-12">
              <div className="lg:col-span-2">
                <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed mb-6 md:mb-8">
                  Det er her Stoad kommer inn. Stoad er vår satsing på neste generasjons treningsapparater med justerbar hoftefleksjon, spesialdesignet CAM som matcher faktiske styrkeprofiler og kapasitet på 240 kg.
                </p>
                <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed mb-6 md:mb-8">
                  Målet er bedre aktivering av quadriceps – spesielt rectus femoris – for både prestasjon og rehabilitering. Veien fra «nice pump» til «bedre knær» er kort hos oss.
                </p>
                
                <div>
                  <h4 className="text-lg md:text-xl font-bold text-white mb-3">Tekniske spesifikasjoner</h4>
                  <div className="space-y-2 text-sm sm:text-base text-white/80">
                    <div>• Justerbar hoftefleksjon</div>
                    <div>• Spesialdesignet CAM-system</div>
                    <div>• 240 kg maksimal kapasitet</div>
                    <div>• Optimalisert for quadriceps aktivering</div>
                  </div>
                </div>
              </div>
              
              <div className="lg:col-span-1">
                <div className="space-y-4">
                  <div className="bg-black/50 p-3 rounded-lg border border-zinc-600">
                    <img src={stoadMachineFront} alt="STOAD treningsapparat - Front med 240kg kapasitet" className="rounded-md w-full h-auto" />
                  </div>
                  <div className="bg-black/50 p-3 rounded-lg border border-zinc-600">
                    <img src={stoadMachineSide} alt="STOAD treningsapparat - Side perspektiv" className="rounded-md w-full h-auto" />
                  </div>
                </div>
              </div>
            </div>
            
            {/* Technical drawings and CAM system */}
            <div className="mt-6 md:mt-0 md:-mt-36 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 items-end">
              <div className="bg-black/30 p-4 rounded-lg border border-zinc-600">
                <img src={stoadTopView} alt="STOAD tekniske tegninger - Topp og side visning" className="rounded-md w-full h-auto mb-3" />
                <p className="text-white/60 text-sm text-center">Tekniske tegninger</p>
              </div>
              <div className="bg-black/30 p-4 rounded-lg border border-zinc-600">
                <img src={stoadFrontView} alt="STOAD tekniske tegninger - Front visning" className="rounded-md w-full h-auto mb-3" />
                <p className="text-white/60 text-sm text-center">Front perspektiv</p>
              </div>
              <div className="sm:col-span-2 lg:col-span-1 flex justify-end">
                <div className="bg-black/50 p-3 rounded-lg border border-zinc-600 w-full">
                  <img src={stoadCamMechanism} alt="STOAD CAM-system for optimal motstand" className="rounded-md w-full h-auto" style={{
                    clipPath: 'inset(0 0 0 5%)'
                  }} />
                </div>
              </div>
            </div>
          </Card>
        </div>
      </section>

      {/* Final Section - Philosophy & CTA */}
      <section className="py-12 md:py-20 lg:py-24 bg-gradient-to-t from-zinc-900 to-black relative">
        {/* Timeline marker - I dag */}
        <div className="absolute left-4 md:left-8 top-20 hidden md:block">
          <div className="w-4 h-4 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full -ml-2 shadow-lg shadow-yellow-400/50 border-2 border-white animate-pulse" />
          <div className="absolute left-6 -top-1 whitespace-nowrap">
            <span className="text-sm font-bold text-yellow-400">Okt 2025</span>
            <span className="block text-xs text-white/70">I dag</span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 md:pl-20 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 md:mb-12">
            <span className="gradient-text">Fremtiden</span> bygges sammen med deg
          </h2>
          
          <div className="max-w-4xl mx-auto space-y-6 md:space-y-8 mb-12 md:mb-16">
            <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
              Filosofien vår er enkel: færre, bedre produkter. Vi har få produkter, og det kommer vi alltid til å ha. Helt ærlig – mye av kosttilskudd der ute gir liten eller ingen effekt, og det styrer vi unna. Vi selger bare det som har solid vitenskapelig dokumentasjon og et tydelig formål.
            </p>
            
            <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
              Og ja – logistikken vår er like målbevisst som produktutviklingen. Med robotlager går alt automatisk i det øyeblikket du bestiller: varen plukkes, pakkes og frakten bestilles på sekunder, sendt samme dag – eller tidlig neste virkedag hvis du bestiller sent.
            </p>
            
            <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
              Dette er starten, ikke målet. Vi inviterer deg til å følge reisen videre – fra PEVEO til Stoad – der vitenskap møter innovasjon, og pris møter prestasjon. 
            </p>
            
            <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
              <strong className="text-yellow-400">Har du et treningssenter, klinikk eller butikk?</strong> Vi ønsker samarbeid med alle og tilbyr gunstige avtaler for treningssentre og andre kommersielle aktører. Ta kontakt for å høre om våre forhandlerpriser.
            </p>
            
            <p className="text-lg sm:text-xl md:text-2xl text-white font-bold">
              Vil du bidra til at fremtidens trening blir smartere, tryggere og rimeligere? Ta det første steget nå: Legg i handlekurv, prøv selv – og <strong className="text-yellow-400">tips treningssenteret ditt om å ta kontakt med oss!</strong> Vi vil samarbeide med alle treningssentre og tilbyr svært gunstige priser til kommersielle kunder. Send peveonorge en melding på Instagram når du har tipset senteret ditt, så får du en personlig takk.
            </p>
          </div>
          
          <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold gradient-text">
            Fremtiden vår bygges sammen med deg.
          </div>
        </div>
      </section>
      
      </div> {/* End Timeline Container */}
    </div>;
};
export default OmOss;